/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import FilterMenu from "@/components/Filters/components/FilterMenu";

import { ROUTES } from "../../../shared";
import FilterButton from "../components/FilterButton";
import FilterCheckbox from "../FilterCheckbox/FilterCheckbox";
import FilterDropdown from "../FilterDropdown/FilterDropdown";
import { useFilters } from "../hooks";
import { useStyles } from "../styles";
import { FILTER_NAMES, TRANSLATE_STRINGS } from "../types/enums";

interface SharedFiltersProps {
  route: ROUTES;
  translateStatus?: string;
}

const SharedFilters = ({ route, translateStatus }: SharedFiltersProps) => {
  const { anchorEl, handleOpenMenu, handleCloseMenu, isPartOfFilterMenu } =
    useFilters(route);

  const { t } = useTranslation();

  const { filtersListBlock, separateFilterDropdown } = useStyles({});

  const isDriversPage = route === ROUTES.Drivers;

  return (
    <>
      {!isPartOfFilterMenu() && (
        <FilterDropdown
          route={route}
          translateString={TRANSLATE_STRINGS.Table}
          filterName={FILTER_NAMES.Schedules}
          placeholder={t("Filter##schedule name")}
          css={css(separateFilterDropdown)}
        />
      )}
      <FilterButton
        route={route}
        onOpen={handleOpenMenu}
        hasMoreFilters
        hasLoadingCustomStyle
      />
      <FilterMenu
        isOpen={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        hasMoreFilters
        anchorEl={anchorEl}
      >
        <div css={css(filtersListBlock)}>
          {isPartOfFilterMenu() && (
            <FilterDropdown
              route={route}
              translateString={TRANSLATE_STRINGS.Table}
              filterName={FILTER_NAMES.Schedules}
              placeholder={t("Filter##schedule name")}
            />
          )}

          <FilterDropdown
            route={route}
            filterName={FILTER_NAMES.Statuses}
            placeholder={
              isDriversPage
                ? t("Filter##last activity")
                : t("Filter##device status")
            }
            translateString={translateStatus}
          />

          <FilterDropdown
            route={route}
            filterName={FILTER_NAMES.LastDownload}
            placeholder={t("Filter##last download")}
            translateString={TRANSLATE_STRINGS.LastDownloadFilter}
          />

          {!isDriversPage && (
            <>
              <FilterDropdown
                route={route}
                filterName={FILTER_NAMES.CreditStatuses}
                placeholder={t("Filter##credit status")}
                translateString={TRANSLATE_STRINGS.Filter}
              />

              <div css={css({ gap: "12px", display: "grid" })}>
                <FilterCheckbox
                  filter={FILTER_NAMES.NoDeviceImei}
                  route={route}
                />
                <FilterCheckbox
                  filter={FILTER_NAMES.DeactivatedVehicles}
                  route={route}
                />
              </div>
            </>
          )}
        </div>
      </FilterMenu>
    </>
  );
};

export default SharedFilters;
